class WorkSwiper {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    this.swiper = null;

    if (!this.root) {
      return;
    }

    this.mq = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
    this.onImagesReady = this.onImagesReady.bind(this);

    this.handleChange();

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.handleChange);
    } else {
      this.mq.addListener(this.handleChange);
    }

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  handleChange() {
    if (this.mq.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 12;
    }

    // SP カード間 gap 12px（Figma node 8704:3305）
    return rootFontSize * 1.2;
  }

  init() {
    if (this.swiper) {
      return;
    }
    if (!this.root) {
      return;
    }
    if (typeof Swiper === 'undefined') {
      return;
    }

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: this.getSpaceBetweenPx(),
      loop: true,
      observer: true,
      observeParents: true,
      resistanceRatio: 0,
      allowTouchMove: true,
      touchStartPreventDefault: false,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });
  }

  destroy() {
    if (!this.swiper) {
      return;
    }

    try {
      this.swiper.destroy(true, true);
    } catch (e) {
      this.swiper.destroy();
    }

    this.swiper = null;
  }
}
